export default __webpack_public_path__ + "ce888719b2a23846c0e268c877d1e8ab.svg";